// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDocumentByExternalIdRequestModel from '../../model/get-document-by-external-id-request-model';
import GetDocumentByExternalIdRequestDTO from '../dto/get-document-by-external-id-request-dto';
import dtoSchema from '../schemas/get-document-by-external-id-request-schema';

export default abstract class GetDocumentByExternalIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDocumentByExternalIdRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<GetDocumentByExternalIdRequestDTO>): GetDocumentByExternalIdRequestModel;
  static toModel(dto: DeepPartial<GetDocumentByExternalIdRequestDTO> | undefined | null): GetDocumentByExternalIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDocumentByExternalIdRequestDTO> | undefined | null): GetDocumentByExternalIdRequestModel | undefined {
    return dto ? new GetDocumentByExternalIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDocumentByExternalIdRequestModel> | GetDocumentByExternalIdRequestModel): GetDocumentByExternalIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as GetDocumentByExternalIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDocumentByExternalIdRequestModel, can not map to GetDocumentByExternalIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
